module.exports = __webpack_public_path__ + "img/kefu.44e41c4d.png";